import { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Typography } from "antd";
import { css } from "@emotion/css";

import { AvatarEmployee, Table } from "components/UI";
import classname from "classname";

const ListSuggestionTable = ({
  data,
  params,
  loading,
  selectedRowKeys,
  titleColumn,
  withSelectAll,
  onSelectRow,
  onSelectRowAll,
}) => {
  const { t } = useTranslation();

  const columnsTable = useMemo(() => {
    const columns = [];
    columns.push({
      title: titleColumn ? titleColumn : t("employee.employee_name"),
      dataIndex: "label",
      key: "label",
      sorter: false,
      fixed: "left",
      render: (value, row, index) => {
        return (
          <div className="flex flex-row items-center space-x-2 w-full">
            <AvatarEmployee
              index={index}
              name={value}
              avatarURL={row?.hr_avatar_url || row?.hr_employee?.hr_avatar_url}
            />
            <div className="flex flex-wrap">
              <Typography.Text
                className={classname("text-gray-900 dark:text-white")}
              >
                {value || ""}
              </Typography.Text>
            </div>
          </div>
        );
      },
    });
    return columns;
  }, [t, titleColumn]);

  const rowClassNameHandler = useCallback(
    (record) =>
      `cursor-pointer ${
        record?.is_active === 0
          ? `bg-gray-200 ${css`
              td {
                background-color: #e5e7eb !important;
              }
              #sequence-number {
                color: #9ca3af !important;
              }
            `}`
          : ""
      }`,
    []
  );

  return (
    <div>
      <Table
        loading={loading}
        columns={columnsTable}
        dataSource={data?.data || []}
        pagination={false}
        withNumbering={false}
        rowKey="value"
        isFloatingHeader
        rowClassName={rowClassNameHandler}
        rowSelection={{
          hideSelectAll: !withSelectAll || !!params?.search,
          selectedRowKeys,
          onSelect: onSelectRow,
          onSelectAll: onSelectRowAll,
        }}
      />
    </div>
  );
};

export default ListSuggestionTable;
